// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"692":"0c67de32","697":"3b29b70b","702":"928be6b8"}[chunkId] + ".chunk.js";
};